import React from "react";
import Filters from "./Filters";
import ListTemplate, { listTemplateQueryKey } from "components/ListTemplate";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useQueryClient } from "@tanstack/react-query";
import TrainModal from "train/TrainModal";
import { useLoaderData } from "react-router";

const FlightListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FlightListFrontModel>();

  const queryClient = useQueryClient();

  const onShowChange = () => {
    queryClient.invalidateQueries([listTemplateQueryKey]);
  }

  return <>
    <TrainModal />
    <ListTemplate
      title={RESX.Flight.Flights}
      filterSet="flight_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Flight.Paginated}
      getId={item => item.flightId}
      layout={cardLayout(onShowChange)}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default FlightListApp;
